import { clientLogger } from '@zg-rentals/particles-js-logger/lib/client';

const requestIdMetaTag = document.querySelector('meta[name=request_id]');

let requestId = '';

if (requestIdMetaTag) {
    requestId = requestIdMetaTag.getAttribute('content');
}

const log = clientLogger({
    name: 'rental-manager-web',
    transmitLogPath: `/rental-manager/log?requestId=${requestId}`,
});

global.log = log;

export default log;
